export { default } from './BancoDoAuto25BannerMoveBrasil';
